import Widget from "../../../lib/ui/Widget";
import { C } from "../../../lib/ui/constructors";
var div = C.div;
var img = C.img;
export default class TeleportIcon extends Widget {
    constructor(spot) {
        super();
        this.tooltip(spot.hover());
        this.addClass("ctr-teleport-icon");
        this.append(img(`assets/icons/teleports/${spot.image().url}`), div().text(spot.code()));
    }
}
